/** sessionStorage keys for SMS vendor invite deep link flow */
export const VENDOR_INVITE_TOKEN_KEY = "bmv_vendorInviteToken";
export const VENDOR_INVITE_DATA_KEY = "bmv_vendorInviteData";
/** Set after vendor signup so onboarding can prefill business email */
export const PENDING_VENDOR_SIGNUP_EMAIL_KEY = "bmv_pendingVendorSignupEmail";
